<template>
    <div class="back">
        <v-app id="inspire">
            <v-content >
                <v-container class="text-md-center" fill-height text-xs-center>
                    <v-layout align-center justify-center>
                        <v-flex xs12 md4 align-self-center>
                            <v-card>
                                <v-card-title>
                                    <v-row align="center" justify="center">
                                        <v-img
                                            src="/images/logo/logo-iconic-dark.png"
                                            lazy-src="/images/logo/logo-iconic-dark.png"
                                            aspect-ratio="1"
                                            max-width="100"
                                            max-height="100"
                                        ></v-img>
                                    </v-row>
                                </v-card-title>
                                <v-card-text>
                                    <v-row align="center" justify="center" style="margin-bottom: 5%">
                                        <span class="display-1 font-weight-bold" style="color: #01579B">Connect Group</span>
                                    </v-row>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-row align="center" justify="center">
                                            <v-col cols="12" md="10">
                                                <v-text-field v-model="user.username" :rules="[rules.required]" filled rounded label="Usuário" placeholder="Informe o usuário" :error-messages="error_messages" append-icon="mdi-at"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row col align="center" justify="center">
                                            <v-col cols="12" md="10">
                                                <v-text-field v-model="user.password" :rules="[rules.required]" filled rounded label="Senha" placeholder="Informe a senha" type="password" :error-messages="error_messages" append-icon="mdi-key"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                    <v-row align="center" justify="center">
                                        <v-col cols="12" md="10">
                                            <v-btn block outlined rounded @click="login" :loading="loading">ACESSAR</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-app>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data: () => ({
            user: {},
            credentials: {},
            loading: null,
            valid: null,
            error_messages: null,
            rules: {
                required: value => !!value || 'Campo Obrigatório',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'E-mail Inválido.'
                },
            },
            publicPath: process.env.BASE_URL
        }),
        created() {
            if (this.$route.query) {
                this.credentials.client_id = this.$route.query.client_id
                this.credentials.client_secret = this.$route.query.client_secret
            }
        },
        computed: {
            credential() {
               return window.btoa(this.credentials.client_id +':'+ this.credentials.client_secret) 
            }
        },
        methods: {
            login() {
                if (this.$refs.form.validate()) {
                    var context = this
                    const formData = new FormData();
                    formData.append('grant_type', 'password');
                    formData.append('username', this.user.username);
                    formData.append('password', this.user.password);

                    this.loading = true

                    this.axios.post(this.$store.state.url_api + '/token', formData, {
                        headers: {
                            'Authorization': 'Basic '+ this.credential,
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Accept': '*/*'
                        }
                    })
                    .then(({ data }) => {
                        context.loading = false
                        context.redirect({ access_token: data.access_token, token_type: data.token_type })
                    })
                    .catch(function () {
                        context.error_messages = 'Usuário/Senha inválidos'
                        context.loading = false
                    })
                }
            },
            redirect(value) {
                if (this.$route.query.callback) {
                    window.location = "{0}?token_type={1}&access_token={2}"
                        .replace('{0}', this.$route.query.callback)
                        .replace('{1}', value.token_type)
                        .replace('{2}', value.access_token)
                }
                else {
                    this.$notify({
                        title: 'Login',
                        type: 'success',
                        text: 'Login realizado com sucesso'
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .v-card {
        padding-top: 5%;
        padding-bottom: 5%;
    }
    .v-btn {
        background-color: #FFFFFF;
        color: #01579B !important;
    }
    .v-btn:hover {
        background-color: #01579B;
        color: #FFFFFF !important;
    }
    .back {
        background-image: url(/images/backgrounds/30.jpg);
        
        background-size: cover;
    }
    #inspire {
        background: none;
    }
</style>